import { request as findRequest } from './reducers/find';

// eslint-disable-next-line import/no-default-export
export default {
    POSTCODE_FIND_REQUEST: findRequest,
};
